import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import _classCallCheck from "E:/project/pc/gzqx-byyj-pc/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/project/pc/gzqx-byyj-pc/node_modules/@babel/runtime/helpers/esm/createClass";
// 登录鉴权，用于用cookies判断用户登录的时效性
// cookies失效，那么在整个系统全局弹出弹窗
// 弹窗内容为引导用户付费
// 付费成功引导用户重新登录
import Vue from 'vue';
import store from '@/store';
import LoginOutInstance from '@/components/loginout/main.js';
import * as uuid from 'uuid';
import * as api from '@/api/service-localstorage'; // import moment from 'moment'

var Auth = /*#__PURE__*/function () {
  function Auth() {
    _classCallCheck(this, Auth);

    this.timer = null; // 定时器

    this.time = 180000; // 180000 默认3分钟进行鉴权

    this.observers = {}; // 组件内使用监听监听定时器

    this.isInvalidation = false; // 是否过期
  } // 触发监听


  _createClass(Auth, [{
    key: "notifyObservers",
    value: function notifyObservers() {
      var _this = this;

      Object.keys(this.observers).forEach(function (key) {
        var fn = _this.observers[key];
        if (fn) fn();
      });
    } // 添加一个刷新的监听

  }, {
    key: "addObserver",
    value: function addObserver(fn, target) {
      var _this2 = this;

      if (!target || !(target instanceof Vue)) {
        console.warn('当前实例并非vue组件');
        return;
      }

      if (!fn || !(fn instanceof Function)) {
        console.warn('添加监听需要回调函数');
        return;
      }

      var uid = uuid.v1();
      this.observers[uid] = fn; // 主要是为了释放内存

      target.$once('hook:beforeDestroy', function () {
        delete _this2.observers[uid];
      });
    }
  }, {
    key: "init",
    value: function init() {
      var _this3 = this;

      if (process.env.NODE_ENV === 'development') return;

      var _api$getAuthStorage = api.getAuthStorage(),
          accesstoken = _api$getAuthStorage.accesstoken,
          cookies = _api$getAuthStorage.cookies;

      if (!accesstoken && !cookies) return; // 拦截一些初始化的操作

      this.getCookiesTimeliness();
      this.timer = setInterval(function () {
        _this3.getCookiesTimeliness();
      }, this.time);
    } // 检验cookies

  }, {
    key: "getCookiesTimeliness",
    value: function getCookiesTimeliness() {
      var _this4 = this;

      var _api$getAuthStorage2 = api.getAuthStorage(),
          cookies = _api$getAuthStorage2.cookies,
          accesstoken = _api$getAuthStorage2.accesstoken,
          version = _api$getAuthStorage2.version;

      if (!accesstoken && !cookies) return; // 拦截一些初始化的操作

      api.getCookiesTimeliness({
        cookies: cookies,
        accesstoken: accesstoken
      }).then(function (result) {
        // 有效时做出响应
        store.commit('SET_TIMELINESS', result);
        _this4.isInvalidation = !result; // 这里规则相反

        _this4.invalidationTimeliness();

        _this4.notifyObservers();
      }).catch(function (err) {
        // cookies无效操作
        var error = err.response.data.error;
        var errorCode = error.errorCode,
            errorText = error.errorText;

        if (errorCode + '' === '16501' && errorText.includes('系统')) {
          if (version === "customized") {
            // 定制版到期退出登录
            LoginOutInstance("系统账号已到期");
          } else {
            // 会员登录到期，提示会员到期，续费弹窗
            store.commit('SET_TIMELINESS', false);
            _this4.isInvalidation = !false; // 这里规则相反

            _this4.invalidationTimeliness();

            _this4.notifyObservers();
          }
        } else {
          // 其他场景退出登录，弹窗*秒后退出登录...
          LoginOutInstance("知灾害登录已失效");
        }
      });
    } // 登录时效性

  }, {
    key: "invalidationTimeliness",
    value: function invalidationTimeliness() {
      // Vue.prototype.$memberShow()
      if (!this.isInvalidation) return; // 未过期
      // 过期显示弹窗

      Vue.prototype.$memberShow();
      console.log('cookies 已过期');
    }
  }, {
    key: "destroyed",
    value: function destroyed() {
      this.clearTimer();
    }
  }, {
    key: "clearTimer",
    value: function clearTimer() {
      if (this.timer) clearInterval(this.timer);
    }
  }]);

  return Auth;
}();

var auth = new Auth();
export default auth;